import { EventBusNames } from "@/utils/EventBus";
import { toggleModal } from "@/utils/Helper";
import { defineComponent } from "vue";

export interface IConfirmationAlert {
  title?: string | null;
  message?: string | null;
  confirmationButtonLabel?: string | null;
  cancellationButtonLabel?: string | null;
  confirmCallback: () => Promise<void> | void | null;
  cancelCallback?: () => Promise<void> | void | null;
  buttonColor?: string | null;
  submitting?: boolean;
}

export default defineComponent({
  name: "ConfirmationAlert",
  mounted() {
    this.$eventBus.$on(
      EventBusNames.SHOW_CONFIRMATION_ALERT,
      ({
        title = "Deseja continuar",
        message = "Tem certeza que deseja continuar?",
        confirmationButtonLabel = "Sim",
        cancellationButtonLabel = "Não",
        buttonColor = "secondary",
        confirmCallback,
        cancelCallback,
      }: IConfirmationAlert) => {
        this.title = title;
        this.message = message;
        this.confirmationButtonLabel = confirmationButtonLabel;
        this.cancellationButtonLabel = cancellationButtonLabel;
        this.buttonColor = buttonColor;
        this.confirmCallback = confirmCallback;
        this.cancelCallback = cancelCallback;
        toggleModal("confirm_alert_modal");
      },
    );
  },
  data() {
    return {
      submitting: false,
      confirmCallback: () => {},
      cancelCallback: () => {},
      title: "",
      message: "",
      confirmationButtonLabel: "",
      cancellationButtonLabel: "",
      buttonColor: "",
    } as IConfirmationAlert;
  },
  methods: {
    alertClosed() {
      this.cancelAction();
    },
    async confirmAction() {
      try {
        this.submitting = true;
        await this.confirmCallback();
        toggleModal("confirm_alert_modal");
      } catch (error) {
        console.error(error);
      } finally {
        this.submitting = false;
      }
    },
    cancelAction() {
      if (this.cancelCallback) {
        this.cancelCallback();
      }
      toggleModal("confirm_alert_modal");
    },
  },
});
